import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import moment from 'moment';
import './EmployeeRow.scss';
import NoEmployeePhoto from "../../../img/no-photo-employee.png";
import { formatTime } from "../../../helpers/timeFormat";

const EmployeeRow = ({ employee, isExpanded, onClick, order }) => {
    const [popActive, setPopActive] = useState(false);
    const [clickedWorkday, setClickedWorkday] = useState({});
    const { employeesList } = useSelector(state => state.employees);
    const isAdmin = employeesList.filter(emp => emp.id === employee.id)[0]?.is_admin;
    const rowRef = useRef(null);
    const overtime = formatTime(employee.overtime) || '-';
    const handleExpnsion = () => {
        if (!isExpanded) {
            window.scrollTo({
                top: (order * rowRef.current.scrollHeight),
                behavior: 'smooth'
            });
        }
        onClick();
    };

    const logsData = (workday_logs) => (
        workday_logs?.slice(0)?.reverse().map(log =>
            <>
                <span className="workday-log-pipe"> | </span>
                <span className="logged-before hoverable-text">
                    {formatTime(log.minutes_logged)}
                    <span className="on-hover-area">
                        {moment(log.created_at).utc().format("dddd, Do [of] MMMM ‘YY - hh:mm A")}
                    </span>
                </span>
            </>
        )
    );

    return (
        <>
            <tr className="employee-row" ref={rowRef} onClick={handleExpnsion}>
                <td className="employee-name-photo text-left">
                    <img src={employee?.avatar && employee?.avatar !== '0' ? employee.avatar : NoEmployeePhoto} alt={employee.name || 'Unknown User'} />
                    <span className="employee-name">{employee.name || 'Unknown User'}</span>
                </td>
                <td className="employee-expected-hrs">{(isAdmin ?? true) ? '-' : formatTime(employee.minutes_expected)}</td>
                <td className="employee-recorded-hrs">
                    {formatTime(employee.workdays_sum_minutes_logged) || '-'}
                    {employee.workdays_avg_minutes_logged ?
                        ` (Ø${formatTime(employee.workdays_avg_minutes_logged)})`
                        : <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;</>
                    }

                </td>
                <td className="employee-overtime">{isAdmin ? 'N/A' : overtime}</td>
            </tr>
            {
                employee?.workdays.length
                ? (employee?.workdays.map(workday => (
                    <div key={workday.id} className={`employee-recorded-data ${isExpanded ? 'expanded' : ''}`}>
                        <span className="cell text-left">{moment(workday?.date).format("dddd, Do [of] MMMM ‘YY")}</span>
                        <span className="cell"></span>
                        <span className="cell">
                            { workday.is_day_off || workday.is_sick_day ?
                                    <span className="hoverable-text">
                                        { workday.is_day_off ? 'Day off' : 'Sick day' }
                                        <span className="on-hover-area">
                                            {moment(workday.created_at).utc().format("dddd, Do [of] MMMM ‘YY - hh:mm A")}
                                        </span>
                                    </span>
                                :
                                <>
                                    {formatTime(workday?.minutes_logged)}
                                    {
                                        workday?.workday_logs.length <= 2 ?
                                            <>{logsData(workday?.workday_logs)}</>
                                            :
                                            <>
                                                <div className="hoverable-area" onClick={() => {
                                                        setPopActive(true);
                                                        setClickedWorkday(workday);
                                                    }}>
                                                    {logsData(workday?.workday_logs?.slice(-2))}
                                                    <span> ...</span>
                                                </div>
                                                <div className={`on-big-hover-area ${popActive && 'active'}`}>
                                                    <span className="popup-title">Work day logs</span>
                                                    <i className="close-popup" onClick={() => setPopActive(false)}>x</i>
                                                    <span className="popup-data">
                                                        {formatTime(clickedWorkday.minutes_logged)}
                                                        {logsData(clickedWorkday?.workday_logs)}
                                                    </span>
                                                </div>
                                            </>
                                    }
                                </>
                            }
                        </span>
                        <span className="cell"></span>
                    </div>
                ))) : <div className={`empty-recorded-data ${isExpanded ? 'empty-expanded' : ''}`}>There are no logs!</div>
            }
        </>
    );
};

export default EmployeeRow;